export const getNameFromEmail = (email: string): string => email.split('@')[0];
